module.exports = __webpack_public_path__ + "static/img/footer-logo.2267067.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/footer-logo.svg
// module id = A/dK
// module chunks = 9